/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    ConsumptionRequestDto,
    LogisticsOperationRequestDto,
    TransferOwnershipRequestDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class BottleOperationsControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        checkIn(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: LogisticsOperationRequestDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottleops/checkIns`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        checkOut(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: LogisticsOperationRequestDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottleops/checkOuts`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        consume(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: ConsumptionRequestDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottleops/statuses`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        transferOwnership(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: TransferOwnershipRequestDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottleops/ownershipTransfers`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


}

